import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import Multiselect from 'vue-multiselect'
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import ClientManagementServices from '../../../../clientmanagement/services/clientmanagement.service';
import Loader from '../../../../shared/components/loader'
import CargoBookingServices from '../../../services/cargobooking.service'
import {Validator} from 'vee-validate';
import cargobookingService from '../../../services/cargobooking.service';
import VueElementLoading from 'vue-element-loading';


export default {
    name: 'airwalletratecalculator',
    components:{
    Paginate,
    Multiselect,
    ClientManagementServices,
    Loader,
    VueElementLoading
    },
    data: function() {
        return {
            isLoading:false,
            clientList:[],
            clientName:null,
            originList:[],
            origincity:null,
            destinationList:[],
            destinationcity:null,
            airlineList:[],
            airline:null,
            businessTypeList:[],
            businesstype:null,
            productTypeList:[],
            producttype:null,
            flightTypeList:[],
            flighttype:null,
            physicalweight:null,
            businesstypedisbaled:false,
            walletdata:'',
            viewbifurcationflag:false,
            bifurcationdata:'',
            calculatedamountflag:false
        }
    },
    computed: {

    },
    async mounted() {
        this.isLoading = true;
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.isLoading = false
        this.getClientDetails()
        this.getAirCargoRateOptions()
    },
    methods: {
        async getClientDetails() {
          try {
            let InputPayload = {}
            var CompanyShortList = [];
            let result = await ClientManagementServices.GetClientListByActiveContracts(InputPayload);
            CompanyShortList = result.data.data.rows;
            let tempArr = [];
            for (var i = 0; i < CompanyShortList.length; i++) {
              tempArr.push({
                'id': CompanyShortList[i].clientbusinessaccountid,
                'label': CompanyShortList[i].clientshortname,
                'ContractId': CompanyShortList[i].id,
                'CompanyName': CompanyShortList[i].clientcompanyname,
                'ClientId': CompanyShortList[i].clientid,
                'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
                'ClientBusinessDetailId' :  CompanyShortList[i].clientbusinessdetailid,
              });
            }
           this.clientList = tempArr.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);
          } catch (err) {
            console.log(err);
          }
        },
        async getAirCargoRateOptions(){
          try{
              this.isLoading = true
              let inputpayload ={}
              let result = await CargoBookingServices.getAirCargoData(inputpayload)
              this.isLoading = false
              if(result.data.code==200){
                  await Promise.all([
                      this.getOriginCityList(result.data.data.origincity),
                      this.getDestinationCityList(result.data.data.destinationcity),
                      this.getAirlineList(result.data.data.resultairlinename),
                      this.getBusinessTypeList(result.data.data.resultbusinesstype),
                      this.getProductTypeList(result.data.data.resultproducttype),
                      this.getFlightTypeList(result.data.data.resultflighttype)
                  ])
              }
              else{
                  this.$alertify.error(result.data.message)
              }
          }catch(err){
              this.isLoading = false
              console.log(err)
          }
        },
        async getOriginCityList(data){
          data.forEach(el=>{
              this.originList.push({
                  'id': el.origin,
                  'label':el.origin.toUpperCase()
              })
          })
        },
        async getDestinationCityList(data){
          data.forEach(el=>{
              this.destinationList.push({
                  'id': el.destination,
                  'label':el.destination.toUpperCase()
              })
          })
        },
        async getAirlineList(data){
          data.forEach(el=>{
              this.airlineList.push({
                  'id': el.id,
                  'label':el.airlinename
              })
          })
        },
        async getBusinessTypeList(data){
          data.forEach(el=>{
              this.businessTypeList.push({
                  'id': el.id,
                  'label':el.businesstype
              })
          })
          this.businesstype = this.businessTypeList[0]
          this.businesstypedisbaled = true
        },
        async getProductTypeList(data){
          data.forEach(el=>{
              this.productTypeList.push({
                  'id': el.id,
                  'label':el.producttype
              })
          })
        },
        async getFlightTypeList(data){
          data.forEach(el=>{
              this.flightTypeList.push({
                  'id': el.id,
                  'label':el.flighttype
              })
          })
        }, 
        async calculaterate(){
            try{
                this.isLoading = true
                    let inputpayload= {
                        clientid:this.clientName.ClientId,
                        clientbusinessaccountid:this.clientName.ClientBusinessAccountId,
                        businesstype:this.businesstype.id,
                        airline:this.airline.id,
                        producttype:this.producttype.id,
                        flighttype:this.flighttype.id,
                        origincity:this.origincity.id,
                        destinationcity:this.destinationcity.id,
                        physicalweight:this.physicalweight
                    }
                    let result = await cargobookingService.AirCargoCalculator(inputpayload)
                    this.isLoading= false
                    if(result.data.code==200){
                        this.viewratecarddisabled = false
                        this.walletdata =result.data.data
                        this.calculatedamountflag = true
                    }else{
                        this.calculatedamountflag = false
                        this.$alertify.error(result.data.message)
                    }               
            }catch(err){
                this.isLoading = false
                console.log(err)
            }
        },
        viewBifurcation(){
            this.viewbifurcationflag = true
            this.bifurcationdata = this.walletdata.bifurcation
        },
        closeModal(){
            this.viewbifurcationflag = false
        },
        resetFilter(){
            this.$validator.reset();
            this.physicalweight = null
            this.calculatedamountflag = false
            this.airline = null
            this.flighttype = null
            this.producttype = null
            this.origincity = null
            this.destinationcity = null 
            this.clientName = null
            this.walletdata = ''
        },
        async calculate(){
            this.$validator.validateAll("airtransaction").then(async result => {
              if (result) {
                await this.calculaterate()
              }else {
                return false;
              }
            }).catch((err) => {
              console.log('errors exist',err);
              return false;
            });
            },
      isCheck(evt, item){
        if(evt.target.value<=0){
          if(item == 'physicalweight'){
            this.physicalweight = null
          }	 
           }
          return true;
      },
    }
}


// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/airwalletratecalculator/airwalletratecalculator.component.js